import script from "./DurationBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DurationBar.vue?vue&type=script&setup=true&lang=ts"

import "./DurationBar.vue?vue&type=style&index=0&id=80448994&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80448994"]])

export default __exports__